import React from 'react';
import './index.less';

import filter from 'lodash/filter';

import SummarySection from './SummarySection';
import Diagram from './Diagram';
import Legend from './Legend';
import Countries from './Countries';

import Calendar from '../../../../shared/calendar/main';

import withIntl from '../../../../shared/intl-hoc';
import {Field, reduxForm} from 'redux-form';
import SelectField from '../../../../shared/form-elements/select/field';

const isRocket = process.env.CPA_ENV === 'rocket';

function Analytics({ intl, calendar, apply, analytics, locationsLookups, trafficSources }) {
	const geos = filter(analytics.countries, c => c.cnt > 0);

	return (
		<div>
			<div className='offers-info-analytics-filters'>
				<Calendar intl={intl} {...calendar} />
				<SearchForm intl={intl} locationsLookups={locationsLookups} trafficSources={trafficSources} />
				<button
					className='ui-btn ui-btn-primary'
					onClick={apply}
				>
					Apply
				</button>
			</div>
			<div className='offers-info-analytics-summary'>
				<SummarySection
					title={intl('Предварительных заказов')}
					value={analytics.total_conversions}
					chart='offers-info-analytics-summary-chart1'
				/>
				<SummarySection
					title={intl('Подтвержденных заказов')}
					value={analytics.accepted_conversions}
					chart='offers-info-analytics-summary-chart2'
				/>
				<SummarySection
					title={intl('Отмененных заказов')}
					value={analytics.declined_conversions}
					chart='offers-info-analytics-summary-chart3'
				/>
			</div>
			<div className='offers-info-analytics-general'>
				<Diagram
					analytics={analytics}
					ages={ages}
				/>
				<Legend
					className='offers-info-analytics-legend'
					list={ages}
				/>
				<Countries
					className='offers-info-analytics-countries'
					geos={geos}
				/>
			</div>
		</div>
	);
}

const SearchForm = reduxForm({ form: `analyticsFiltersForm`, enableReinitialize: true })(props => (
	<div className="ui-form clearfix display-flex width-500 position-relative top--20">
		<div className="ui-form__element width-50-p">
			<Field
				name="countries"
				placeholder={props.intl('Location')}
				component={SelectField}
				multi={false}
				showLabel={true}
				searchable={true}
				options={props.locationsLookups}
			/>
		</div>
		<div className="ui-form__element width-50-p margin-0-15">
			<Field
				name="traffic_sources"
				placeholder={props.intl('Traffic source')}
				component={SelectField}
				multi={false}
				showLabel={true}
				searchable={false}
				options={props.trafficSources}
			/>
		</div>
	</div>
));

const ages = !isRocket ? [
	{ color: '#d62c2c', title: 'До 20' },
	{ color: '#f36ab7', title: '20 - 24' },
	{ color: '#833194', title: '25 - 31' },
	{ color: '#7d47e9', title: '32 - 36' },
	{ color: '#0090ff', title: '37 - 39' },
	{ color: '#8d9ff3', title: '40 - 44' },
	{ color: '#00dcff', title: '45 - 51' },
	{ color: '#488609', title: '52 - 54' },
	{ color: '#8caf00', title: '55 - 59' },
	{ color: '#a5d500', title: '60 - 64' },
	{ color: '#93f5b1', title: '65 - 69' },
	{ color: '#f7d038', title: '70 - 74' },
	{ color: '#f5a993', title: '75 - 81' },
	{ color: '#ff8400', title: 'От 82' }
] : [
	{ color: '#d62c2c', title: 'До 25' },
	{ color: '#f36ab7', title: '26 - 35' },
	{ color: '#a5d500', title: '36 - 45' },
	{ color: '#7d47e9', title: '46 - 55' },
	{ color: '#0090ff', title: '56 - 65' },
	{ color: '#f7d038', title: '66 - 75' },
	{ color: '#ff8400', title: 'От 76' }
];

export default withIntl(Analytics);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/info/components/Analytics/index.js